<template>
<div class="list">
    <div class="bottom-bg"></div>
    <div class="top-list">
        <div class="list-title">开奖名单</div>
        <div class="back" @click="backBtn"></div>
        <!-- 时间选择 -->
        <div class="time">
            开奖时间：
            <select name id v-model="date" @change="selectTime">
                <option value="2020-05-31">2020-05-31</option>
                <option value="2020-06-01">2020-06-01</option>
                <option value="2020-06-02">2020-06-02</option>
                <option value="2020-06-03">2020-06-03</option>
                <option value="2020-06-04">2020-06-04</option>
                <option value="2020-06-05">2020-06-05</option>
                <option value="2020-06-06">2020-06-06</option>
            </select>
            <div class="down-arrow"></div>
        </div>
        <!-- <DatePicker :value="value1" format="yyyy年MM月dd日" type="date" placeholder="Select date" style="width: 200px"></DatePicker> -->
        <!-- 名单列表 -->
        <div class="list-con">
            <div class="list-wrapper" v-show="isTimeLine">
                <div class="list-item" v-for="(item, index) in list_arr" :key="index">
                    <div class="left-info">
                        <div class="headimg">
                            <img :src="item.head_img_url" alt />
                        </div>
                        <div class="info-con">
                            <div class="name">@{{item.nickname}}</div>
                            <div class="award-name">
                                奖项：
                                <span style="color:#cf6823">{{item.prize}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="right-award" v-if="item.prize_number == 1">一等奖</div>
                    <div class="right-award" v-if="item.prize_number == 2">二等奖</div>
                    <div class="right-award" v-if="item.prize_number == 3">三等奖</div>
                    <div class="right-award" v-if="item.prize_number == 4">四等奖</div>
                    <div class="right-award" v-if="item.prize_number == 5">五等奖</div>
                </div>
            </div>
            <!-- 未到开奖时间 -->
            <div class="time-return" v-show="!isTimeLine">
                <div class="t1">开奖时间未到，尽请期待～</div>
                <div class="t2">（活动期间开奖时间为每天24点）</div>
            </div>
        </div>
        <!-- <div class="to-all-list"></div> -->
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            gameOver: false,
            isTimeLine: false,
            date: "",
            list_arr: [

            ]
        };
    },
    methods: {
        selectTime(e) {
            this.list_arr = []
            this.getList(this.date)
        },
        backBtn() {
            this.$router.go(-1)
        },
        //根据日期获取列表
        getList(date) {
            this.$axios
                .post("/h5/api/getPrizeList", {
                    date: date
                }, {})
                .then(res => {
                    if (res.data.code === 0) {
                        console.log(res.data.data.data, '获奖列表')
                        let list = res.data.data.data
                        this.list_arr = list
                        if(list.length == 0) {
                            this.isTimeLine = false
                        }else {
                            this.isTimeLine = true
                        }
                    }
                });
        },
        //获取当前的日期  -1天
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate() - 1;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        //设置分享
        setWxShare() {
            let openId = localStorage.getItem('openId')
            let avatar = localStorage.getItem('avatar')
            let username = localStorage.getItem('username')
            // let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}&myavatar=${avatar}&myname=${username}`
            let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}`
            console.log(shareUrl)
            // shareUrl = "http://test.smalltea.xiaoxxx.cn/#/Msupport?myopenid=123&myavatar=888"
            // alert(shareUrl)
            // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        console.log(url);
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
                // 1.2.0 老接口
                wx.onMenuShareAppMessage({
                    title: "乘风破浪·粽享端午", // 分享标题
                    desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
                    }
                });
                wx.onMenuShareTimeline({
                    title: "乘风破浪·粽享端午", // 分享标题
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
                    success: function () {
                        // 设置成功
                        window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数', '1', '1']);
                    }
                });
            });
        },
         // 倒计时
        timer(time) {
            var nowtime = new Date();
            var endTime = new Date(time);
            var lefttime = parseInt((endTime.getTime() - nowtime.getTime()) / 1000);
            var d = parseInt(lefttime / (24 * 60 * 60));
            var h = parseInt((lefttime / (60 * 60)) % 24);
            var m = parseInt((lefttime / 60) % 60);
            var s = parseInt(lefttime % 60);
            if (lefttime <= 0) {
               this.date = '2020-06-06'
               this.getList('2020-06-06')
            } else {
                // console.log(d,h,m,s)
            }
        },
    },
    created() {
        this.setWxShare()
        let currentdate = this.getNowFormatDate()
        if(currentdate == '2020-05-30') {
            currentdate = '2020-05-31'
        }
        this.getList(currentdate)
        this.timer('2020-06-06')
        this.date = currentdate
    }
};
</script>

<style scoped>
.list {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 12.8rem;
    background-color: #d3f5ea;
    /* background: url('../../assets/H5img/indexImg/bg-index.jpg') no-repeat;
    background-size: cover;
    background-position: center; */
    overflow: hidden;
}

.bottom-bg {
    position: absolute;
    width: 7.5rem;
    height: 4.33rem;
    bottom: 0;
    left: 0;
    background: url("../../assets/H5img/list/bottom-bg.png") no-repeat;
    background-size: cover;
    background-position: center;
}

.list-title {
    position: absolute;
    top: 0.4rem;
    left: 50%;
    transform: translateX(-50%);
    color: #254740;
    font-size: 0.36rem;
    font-weight: bold;
}

.back {
    position: absolute;
    top: 0.5rem;
    left: 0.54rem;
    width: 0.25rem;
    height: 0.43rem;
    background: url("../../assets/H5img/award/back.png") no-repeat;
    background-size: cover;
    background-position: center;
}

.time {
    position: absolute;
    top: 1.55rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6.2rem;
}

select {
    width: 4.44rem;
    height: 0.5rem;
    border: solid 1px #41504d;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: none;
    text-indent: 0.1rem;
}

.down-arrow {
    position: absolute;
    right: 0.4rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.2rem;
    height: 0.13rem;
    background: url("../../assets/H5img/list/down-arrow.png") no-repeat;
    background-size: cover;
    background-position: center;
}

.list-con {
    position: absolute;
    /* box-sizing: border-box; */
    top: 2.4rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6.39rem;
    height: 8.56rem;
    background: url("../../assets/H5img/list/list-bg.png") no-repeat;
    background-size: cover;
    background-position: center;
    overflow: scroll;
    margin: 0.2rem 0 0.3rem 0;
}

.list-wrapper {
    position: absolute;
    width: 90%;
    height: 90%;
    top: 0.2rem;
    left: 50%;
    transform: translateX(-50%);
    overflow: scroll;
}

.list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 5.2rem;
    height: 1rem;
    /* line-height: 1rem; */
    margin: 0 auto;
    border-bottom: 1px dashed #67a295;
}

.left-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.headimg {
    width: 0.6rem;
    height: 0.6rem;
    background: #d3f5ea;
    border-radius: 50%;
    overflow: hidden;
}

.headimg img {
    width: 100%;
    height: 100%;
}

.info-con {
    position: relative;
    /* display: flex;
    justify-content: flex-start;
    align-items: center; */
    width: 3.5rem;
    height: 100%;
    margin-left: 0.1rem;
    font-size: 0.18rem;
}

.name {
    display: inline-block;
    width: 100%;
    height: 0.48rem;
    line-height: 0.6rem;
    color: #465e59;
}

.award-name {
    display: inline-block;
    width: 100%;
    height: 0.48rem;
    line-height: 0.4rem;
    color: #67a295;
}

.to-all-list {
    position: absolute;
    bottom: 1.2rem;
    left: 50%;
    transform: translateX(-50%);
    width: 3.17rem;
    height: 0.85rem;
    background: url("../../assets/H5img/list/all-list.png") no-repeat;
    background-size: cover;
    background-position: center;
}

.time-return {
    position: absolute;
    top: 3.4rem;
    left: 50%;
    width: 100%;
    text-align: center;
    transform: translateX(-50%);
}

.t1 {
    font-size: 0.36rem;
    color: #31423e;
    margin-bottom: 0.4rem;
    font-weight: bold;
}

.t2 {
    color: #31423e;
    font-size: 0.3rem;
}
</style>
